<template>
  <svg data-icon-name="facebook" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.613 28.753"><path d="M10.528 6.116h2.969a.36.36 0 0 0 .365-.365V1.135a.36.36 0 0 0-.364-.367H9.431C7.76.642 6.11 1.203 4.862 2.321A5.25 5.25 0 0 0 3.45 6.253v3.29H1.115a.36.36 0 0 0-.365.365v4.477a.36.36 0 0 0 .365.365H3.45v12.887a.36.36 0 0 0 .365.365h5.483a.36.36 0 0 0 .365-.365V14.702h3.336c.163.009.304-.112.32-.275 0 0 .365-2.193.5-4.524a.65.65 0 0 0-.092-.275c-.045-.092-.137-.092-.227-.092H9.66V6.847c.106-.403.453-.696.868-.732z" fill="none" stroke="#000a12" stroke-miterlimit="10" stroke-width="1.5"/></svg>
</template>

<script>
import {
  defineComponent,
} from 'vue';

export default defineComponent({});
</script>
